import axiosInstance from "../utils/axiosInstance";
import { TokenDecrypt } from "../utils/encryptionDecryption";
const mapToOptions = (data, labelKey = 'name', valueKey = 'code') => {
    return data.map(item => ({ label: item[labelKey], value: item[valueKey] }));
};
export const getCoursesCategoryFromServer = async (page = 1,pageSize = 10) => {
  try {
    const response = await axiosInstance.get(`categories?page=${page}&limit=${pageSize}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if(response && response.data && response.data.encryptedData){
      const decryptedData = TokenDecrypt(response.data.encryptedData);
      return decryptedData.data;
    }
      return [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw new Error("Failed to fetch categories");
  }
};

export const addCourseCategory = async (courseCategoryData) => {
    try {
      const jsonData = Object.fromEntries(courseCategoryData.entries());
      const response = await axiosInstance.post("categories", jsonData, {
        headers: {
            "Content-Type": "application/json",
        },
      });
      return response
    } catch (error) {
      console.error("Error adding Course Category:", error);
      throw new Error("Failed add Course Category");
    }
  };

// export const updateCourse = async (courseId, courseData) => {
//     try {
//       const jsonData = Object.fromEntries(courseData.entries());
      
//       const response = await axiosInstance.put(`courses/${courseId}`, jsonData, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });
//       return response;
//     } catch (error) {
//       console.error("Error updating Course:", error);
//       throw new Error("Failed to update Course");
//     }
//   };

  export const deleteCourse = async (id) => {
  try {
    const response = await axiosInstance.delete(`/courses/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Failed to delete course.";
    console.error("Error in deleteCourse:", errorMessage);
    throw new Error(errorMessage);
  }
};

